import { render, staticRenderFns } from "./NewPerson.vue?vue&type=template&id=d92b6104&scoped=true"
import script from "./NewPerson.vue?vue&type=script&lang=js"
export * from "./NewPerson.vue?vue&type=script&lang=js"
import style0 from "./NewPerson.vue?vue&type=style&index=0&id=d92b6104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92b6104",
  null
  
)

export default component.exports